// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import _ from "lodash"
import DebtPhaseContracts from "../../components/DebtPhaseContracts"
import DebtPhaseDocuments from "../../components/DebtPhaseDocuments"
import DebtPhaseMbReference from "../../components/DebtPhaseMbReference"
import DebtPhaseExpenses from "../../components/DebtPhaseExpenses"
import PreLitigationDetails from "../../components/PreLitigationDetails"
import SimpleTable from "../../components/SimpleTable"
import Hidable from "../../components/Hidable"
import SaveButton from "../../components/SaveButton"
import { connect } from "react-redux"
import { getPreLitigationById } from "../../actions"
import * as strings from "../../strings"
import DebtSummaryHeader from "../../components/DebtSummaryHeader"
import { toastr } from "react-redux-toastr"
import DebtPhaseOptions from "../../components/DebtPhaseOptions"
import {
  formatCurrency,
  formatDate,
  cleanupOption,
} from "../../utils"
import {
  getDebtById,
  updatePrelitigation,
  sendPreLitigationNotification
} from "../../actions"

const PRELITIGATION_OPTIONS_TYPE = 1

class PreLitigationView extends Component {
  props: {
    debt: any,
    getDebtById: any,
    auth: {
      token: string,
    },
    match: {
      path: string,
      params: {
        preLitigationId: string,
      },
    },

    mainContactId: number,
    contacts: any[],
  }

  state = {
    request: {
      preLitigation: undefined,
    },
    preLitigation: undefined,
  }


  fetchPreLitigation = preLitigationId => getPreLitigationById( this.props.auth.token, preLitigationId )
    .then( response => {
      const preLitigation = ( response.message !== "OK" ) ? null : response.result
      return this.setState( {
        request: {
          ...this.state.request,
          preLitigation,
        },
        preLitigation,
      } )
    } )

  componentWillMount = () => {
    const litigationId = parseInt( this.props.match.params.preLitigationId, 10 )
    this.fetchPreLitigation( litigationId )
      .then( () => {
        this.props.getDebtById( this.state.preLitigation.idDebt )
      } )
  }

  renderDetails = mainDebtor => (
    <div style={ { "padding-top": "15px" } }>
      <PreLitigationDetails
        token={this.props.auth.token}
        preLitigation={this.state.preLitigation}
        mainDebtor={mainDebtor}
        onChange={newDetails => this.setState( {
          preLitigation: {
            ...this.state.preLitigation,
            ...newDetails,
          },
        } ) }
      />
    </div>
  )


  renderContracts = preLitigation => {
    const INVOICE_COLUMNS = {
      documento: { title: "Documento" },
      dataDocumento: { title: "Data Documento" },
      nItem: { title: "Nº Item" },
      nOficialDocumento: { title: "Nº Oficial Documento" },
      contaContrato: { title: "Conta Contrato" },
      contrato: { title: "Contrato" },
      transacaoPrincipal: { title: "Transação Principal" },
      montanteDocumento: { title: "Montante Documento", align: 'right' },
      dataVencimento: { title: "Data Vencimento" },
    }
    const formatted = _.chain(preLitigation.importedEDPPrelitigationRows)
      .map(a => _.pick(a, ['nItem', 'documento', 'dataDocumento', 'nOficialDocumento', 'contaContrato', 'contrato', 'transacaoPrincipal', 'montanteDocumento', 'dataVencimento']))
      .map( a => ( {
        ...a,
        dataDocumento: formatDate( a.dataDocumento ),
        montanteDocumento: formatCurrency( a.montanteDocumento ),
        dataVencimento: formatDate( a.dataVencimento ),
      } ) )
      .value()
    
    return (
      <Hidable title="Faturas">
        <SimpleTable sortable={true} columns={INVOICE_COLUMNS} data={formatted} />
      </Hidable>
    )
  }

  renderContracts2 = preLitigation => {
    const INVOICE_COLUMNS = {
      carteira: { title: "Carteira" },
      nDoc: { title: "Documento" },
      valor: { title: "Montante Documento", align: 'right' },
    }
    const formatted = _.chain(preLitigation.importedEDPPrelitigationInterestRows)
      .map(a => _.pick(a, ['carteira', 'nDoc', 'valor']))
      .map( a => ( {
        ...a,
        valor: formatCurrency( a.valor ),
      } ) )
      .value()
    
    return (
      <Hidable title="Juros de Mora">
        <SimpleTable sortable={true} columns={INVOICE_COLUMNS} data={formatted} />
      </Hidable>
    )
  }

  renderMbReference = preLitigation => {
    return (
      <DebtPhaseMbReference mbReference={preLitigation.mbReference} />
    )
  }

  renderDocuments = ( preLitigation ) => {
    return (
      <DebtPhaseDocuments
        documents={preLitigation.documents}
        onChange={newDocuments => this.updatePreLitigationAndRequest( {
          documents: newDocuments,
        } ) }

        phaseId={preLitigation.id}
        fileDownloadCommand="getPreLitigationDocument"

        fileUploadCommand="newPreLitigationDocuments"
        fileRemoveCommand="removePreLitigationDocument"
        fileUploadArgs={{
          id: preLitigation.id,
        }}
      />
    )
  }

  updatePreLitigationAndRequest = newData => {
    const newPreLitigation = {
      ...this.state.preLitigation,
      ...newData,
    }

    this.setState( {
      request: {
        ...this.state.request,
        preLitigation: newPreLitigation,
      },
      preLitigation: newPreLitigation,
    } )
  }

  save = () => {
    const { preLitigation } = this.state
    const preLitigationFormatted = {
      id: preLitigation.id || null,
      idc: !_.isEqual( preLitigation.idc, "" ) ? preLitigation.idc : null,
      interest: preLitigation.interest && parseFloat( preLitigation.interest ),
      activeOption: cleanupOption( preLitigation.activeOption, [ "validFrom" ] ),
    }
    this.updatePreLitigationAndRequest( preLitigationFormatted )
    updatePrelitigation( this.props.auth.token, preLitigationFormatted )
      .then( () => toastr.success( strings.generalStrings.changesSaved ) )
      .catch( () => toastr.error( strings.generalStrings.errorSaving ) )
  }

  reset = () => this.setState( {
    preLitigation: this.state.request.preLitigation,
  } )

  render () {
    const { preLitigation } = this.state

    // TODO: Some kind of loading animation
    // We can probably continue without debtorsInfo
    if ( preLitigation === undefined ) {
      return <div />
    }

    if ( preLitigation === null ) { // TODO: Better error handling
      return (
        <div>
          {strings.errorMessages.anErrorHasOccurred}
        </div>
      )
    }

    return (
      <div>
        <DebtSummaryHeader
          title={strings.generalStrings.debt}
          debt={this.props.debt}
          isProcessPhase={true}
          plid={preLitigation.plid}
          phaseTotalValue={preLitigation.totalValue}
          phaseUpaidValue={preLitigation.unpaidValue}
          phasePaidValue={preLitigation.paidValue}
          phaseName={strings.DebtPhaseTranslation.PreLitigation}
          sendNotification={() => sendPreLitigationNotification( this.props.auth.token, preLitigation.id )
            .then( () => toastr.success( "Notificação enviada" ) )
            .catch( () => toastr.error( "Erro a enviar notificação" ) )}
          carteira={_.get(preLitigation, "lot.externalReference")}
        />
        <DebtPhaseOptions
          debtPhaseEnum="PreLitigation"
          debtPhase={preLitigation}
          debt={this.props.debt}
          debtPhaseId={parseInt( this.props.match.params.preLitigationId, 10 )}
          onChange={newDetails => this.setState( {
            preLitigation: {
              ...this.state.preLitigation,
              activeOption: {
                ...this.state.preLitigation.activeOption,
                ...newDetails,
              },
            },
          } ) }
          parentOption={this.state.preLitigation.activeOption}/>
        {this.renderDetails()}
        {this.renderMbReference( preLitigation )}
        {this.renderContracts( preLitigation )}
        {this.renderContracts2( preLitigation )}
        {this.renderDocuments( preLitigation )}
        <SaveButton
          onSave={this.save}
          onCancel={this.reset}
          show={
            !_.isEqual( this.state.request.preLitigation, this.state.preLitigation )
          }
        />
      </div>
    )
  }
}

export default connect( store => ( { auth: store.auth, debt: store.getDebt } ),
  { getDebtById } )( PreLitigationView )



// WEBPACK FOOTER //
// ./src/views/PreLitigationView/index.jsx